import React from 'react';

export const StoreContext = React.createContext({} as any);

const ContextStore = ({ children }: any) => {
  const [organisme, setOrganisme] = React.useState(null);
  const [organismeListItem, setOrganismeListItem] = React.useState(null);
  const [organismeListPac, setOrganismeListPac] = React.useState(null);
  const [organismeList, setOrganismeList] = React.useState([]);
  const [mandatoryFiles, setMandatoryFiles] = React.useState([]);
  const [foldersList, setFoldersList] = React.useState([]);
  const [concernedPeople, setConcernedPeople] = React.useState([]);
  const [testSuccessProcess, setTestSuccessProcess] = React.useState(null);
  const [isLoadingParams, setIsLoadingParams] = React.useState<boolean>(false);
  const [isLoadingDMO, setIsLoadingDMO] = React.useState<boolean>(false);
  const [checkFirstDeclare, setCheckFirstDeclare] = React.useState(false);
  const [
    declareFolderProcessSteps,
    setDeclareFolderProcessSteps,
  ] = React.useState(0);
  const [PACProcessStep, setPACProcessStep] = React.useState(0);
  const store = {
    organismeState: { organisme, setOrganisme },
    declareFolderProcessStepsState: {
      declareFolderProcessSteps,
      setDeclareFolderProcessSteps,
    },
    organismeListItemState: {
      organismeListItem,
      setOrganismeListItem,
    },
    organismeListPacState: {
      organismeListPac,
      setOrganismeListPac,
    },
    organismeListState: { organismeList, setOrganismeList },
    mandatoryFilesState: { mandatoryFiles, setMandatoryFiles },
    foldersListState: { foldersList, setFoldersList },
    concernedPeopleState: { concernedPeople, setConcernedPeople },
    successTestState: { testSuccessProcess, setTestSuccessProcess },
    isLoadingDMOState: { isLoadingDMO, setIsLoadingDMO },
    checkFirstDeclareState: { checkFirstDeclare, setCheckFirstDeclare },
    isLoadingParamsState: { isLoadingParams, setIsLoadingParams },
    // --------------   PAC store  -----------------
    PACProcessStepsState: {
      PACProcessStep,
      setPACProcessStep,
    },
  };

  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};
export default ContextStore;
